import { Icon, Typography } from "@/components/atoms";

interface ConfirmationSuccessHeaderProps {
  /**
   * The booking's display number (e.g. "J123456"). When present the heading names the booking —
   * "Booking #J123456 Confirmed!" — matching the design; otherwise it falls back to the generic title
   * (e.g. on a hard refresh, where the confirmation's router-state snapshot — and so the id — is gone).
   */
  displayJobId?: string;
  /**
   * Managed client's name when booking on their behalf (operator/EA OBO) — the subtext then names the
   * client ("Liam's trip is confirmed…") instead of the self-service "Your trip…". Undefined self-service.
   */
  clientName?: string;
}

/** Green success badge + heading + subtext shown at the top of the confirmation page. */
export const ConfirmationSuccessHeader = ({ displayJobId, clientName }: ConfirmationSuccessHeaderProps) => {
  const clientFirstName = clientName?.trim().split(" ")[0];
  return (
    <div className="flex flex-col items-center text-center">
      {/* 72px success-light ring → 40px success circle → white TickCircle */}
      <div className="flex h-[72px] w-[72px] items-center justify-center rounded-full bg-success-light">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-success">
          <Icon name="TickCircle" size="lg" className="text-white" />
        </div>
      </div>

      <Typography variant="h2" className="mt-5">
        {displayJobId ? `Booking #${displayJobId} Confirmed!` : "Booking Trip Successful!"}
      </Typography>
      <Typography variant="paragraph" className="mt-2 max-w-[520px] text-neutral-dark-gray">
        {clientFirstName
          ? `${clientFirstName}'s trip is confirmed! For scheduled rides, review the details and ensure they're ready at the pickup time.`
          : "Your trip is confirmed! For scheduled rides, check the details and be ready at the pickup time."}
      </Typography>
    </div>
  );
};
